import { Link } from "react-router-dom";
import ProductoImagen from "./ProductoImagen.jsx";
import { useCarrito } from "../../lib/CarritoContext.jsx";
import { soles } from "../../lib/format";
import { etiqueta } from "../../lib/etiquetas";
import s from "./ProductoCard.module.css";

export default function ProductoCard({ producto }) {
  const { agregar } = useCarrito();
  const sinStock = typeof producto.stock === "number" && producto.stock <= 0;

  return (
    <article className={s.card}>
      <Link to={`/productos/${producto.id}`} className={s.enlaceImagen}>
        <ProductoImagen producto={producto} alto={170} />
        {producto.destacado && <span className={s.destacado}>Mas pedido</span>}
      </Link>

      <div className={s.cuerpo}>
        <p className={`mono ${s.sku}`}>{producto.sku}</p>

        <h3 className={s.nombre}>
          <Link to={`/productos/${producto.id}`}>{producto.nombre}</Link>
        </h3>

        <ul className={s.specs}>
          {Object.entries(producto.especificaciones || {})
            .filter(([clave]) => clave !== "pesoUnitario")
            .slice(0, 3)
            .map(([clave, valor]) => (
              <li key={clave}>
                <span className={s.specClave}>{etiqueta(clave)}</span>
                <span className={s.specValor}>{valor}</span>
              </li>
            ))}
        </ul>

        <div className={s.pie}>
          <div className={s.precio}>
            <span className={s.monto}>{soles(producto.precio)}</span>
            <span className={s.unidad}>/ {producto.unidad}</span>
            {producto.precio !== null && (
              <span className={s.igvNota}>Precio sin IGV</span>
            )}
          </div>

          <button
            type="button"
            className="btn btn--sm btn--accent"
            onClick={() => agregar(producto, 1)}
            disabled={sinStock}
          >
            {sinStock ? "Sin stock" : "Agregar"}
          </button>
        </div>
      </div>
    </article>
  );
}
